import type { Page } from './utils';
import { fmtDec, fmtDuration, fmtInt, fmtTime, groupByTimezone, hasCause } from './utils';
import { causeMeta } from './errorCatalog';
import s from './BroadcastDetailsModal.module.css';

interface Props { pages: Page[]; cause: string | null; appName: (id: number) => string }

export function ExecutionsTab({ pages, cause, appName }: Props) {
  const groups = groupByTimezone(pages);
  if (!groups.length) return <div className={s.empty}>Nenhuma página encontrada</div>;
  return (
    <div className={s.scrollPad}>
      {groups.map((g) => {
        const late = g.pages.filter((p) => p.delay > 1).length;
        return (
          <div key={g.tz} className={s.group}>
            <div className={s.groupHead}>
              <span>{g.tz} — {g.pages.length} páginas</span>
              <span className={s.muted}>{g.pages.filter((p) => p.ok).length} enviadas{late ? ` · ${late} com atraso >1 min` : ''}</span>
            </div>
            <div className={`${s.execGrid} ${s.tHead}`}>
              <span>Página</span><span>Status</span><span>Agendado</span><span>Disparou</span><span>Concluiu</span><span>Duração</span><span>Atraso</span><span>Env / Ent</span><span className={s.right}>Falhas</span>
            </div>
            {g.pages.map((p) => (
              <div key={p.id} className={`${s.execGrid} ${s.tRow}`} style={{ opacity: cause && !hasCause(p, cause) ? 0.3 : 1 }}>
                <div className={s.nameCell}><b>{p.name}</b><small>{appName(p.app)}</small></div>
                <span><span className={p.ok ? s.pillOk : s.pillFail}>{p.ok ? 'Enviado' : 'Falhou'}</span></span>
                <span className={s.muted}>{fmtTime(p.sch)}</span>
                <span>{fmtTime(p.s, true)}</span>
                <span>{fmtTime(p.e, true)}</span>
                <span>{fmtDuration(p.e - p.s)}</span>
                <span style={{ color: p.delay > 1 ? '#c2410c' : '#6b7280', fontWeight: 600 }}>{fmtDec(p.delay)} min</span>
                <span className={s.envEnt}>{fmtInt(p.sent)} <i>/</i> <em>{fmtInt(p.deliv)}</em></span>
                <span className={s.failCell} title={p.errs.map((e) => `${fmtInt(e.n)} — ${causeMeta(e.key, e.message).description}`).join('\n')}>
                  {p.errs.map((e) => <i key={e.key} className={s.sqSm} style={{ background: causeMeta(e.key).color }} />)}
                  <b style={{ color: p.fail ? '#dc2626' : '#9ca3af' }}>
                    {p.fail ? fmtInt(p.fail) : p.errs.some((e) => e.key === 'sem_lead_elegivel') ? 'sem leads' : '–'}
                  </b>
                </span>
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
}
